import Text from "shared/ui/typography/Text";
import Container from "shared/ui/container";

const CheckoutNoProducts = () => {
  return (
    <Container className="gg-px-4 sm:gg-px-14 md:gg-px-32 lg:gg-px-14 xl:gg-px-32">
      <Text>Geen products.</Text>
    </Container>
  );
};
export default CheckoutNoProducts;
